/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import 'devextreme/data/odata/store';


import ODataStore from 'devextreme/data/odata/store';
import FileUploader from 'devextreme-react/file-uploader';

import DataGrid, {
  Column,
  Grouping,
  GroupPanel,
  Pager,
  Paging,
  SearchPanel,
  Scrolling,
  TotalItem,
  GroupItem,
  Summary,
  Export,
  Selection,
} from 'devextreme-react/data-grid';

import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';

const pageSizes = [10, 25, 50, 100];
const exportFormats = ['csv', 'xls'];

const dataSourceOptions = {
  store: new ODataStore({
    //url: 'https://js.devexpress.com/Demos/SalesViewer/odata/DaySaleDtoes',
    url: 'https://etf-service.azurewebsites.net/api/etf/doc',
    key: 'ticker',
    beforeSend(request) {
      //const year = new Date().getFullYear() - 1;
      //request.params.date = `${year}-05-10`;
    },
  }),
};

const calculateCustomSummary = (options) => {
  // Calculating "customSummary1"

  switch (options.summaryProcess) {
    case "start":
      // Initializing "totalValue" here
      options.totalValue = 0;
      break;
    case "calculate":
      // Modifying "totalValue" here
      options.totalValue = 2;
      break;
    default:
      break;

    case "finalize":
      options.totalValue = 123; // Assigning the final value to "totalValue" here
      break;
  }
}

const onExporting = (e) => 
 {
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet('Main sheet');

  exportDataGrid({
    component: e.component,
    worksheet,
    autoFilterEnabled: true,
  }).then(() => {
    if(e.format === 'csv'){
      workbook.csv.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.csv');
    })};
    if(e.format === 'pdf'){
      workbook.pdf.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.pdf');
    })};
    if(e.format === 'xsl'){
      workbook.xsl.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.xsl');
    }
    )};
  })
};

export default () => (
  <React.Fragment>
    <Scrolling columnRenderingMode="virtual" />
    <h2 className={'content-block'}>ETF Details</h2>

    <div>Version 1.0.4</div>
    
    <FileUploader
      multiple={false}
      accept="*"
      uploadMode="instantly"
      name='formFile'
      uploadUrl={"https://etf-service.azurewebsites.net/api/etf/upload"}
    />

    <DataGrid
      dataSource={dataSourceOptions}
      allowColumnReordering={true}
      rowAlternationEnabled={true}
      columnAutoWidth="true"
      showBorders={true}
      width="100%"
      //onContentReady={this.onContentReady}
      onExporting={onExporting}
    >

      <GroupPanel visible={true} />
      <SearchPanel visible={true} highlightCaseSensitive={true} />
      <Export enabled={true} allowExportSelectedData={true} formats={exportFormats} />
      <Grouping autoExpandAll={true} />
      <Selection mode="multiple" />
      <Scrolling columnRenderingMode="virtual" />
      

      <Column dataField="ticker" columnAutoWidth="true" /*groupIndex={0}*/ />
      <Column dataField="name" columnAutoWidth="true" dataType="date" />
      <Column dataField="assetClass" columnAutoWidth="true" dataType="string" />
      <Column dataField="sector" columnAutoWidth="true" dataType="string" />
      <Column dataField="marketValue" columnAutoWidth="true" dataType="number" format="##########" />
      <Column dataField="weight" columnAutoWidth="true" dataType="number" format="#####0.##" />
      <Column dataField="price" columnAutoWidth="true"  dataType="number" format="#####0.00" />
      <Column dataField="shares" columnAutoWidth="true" dataType="number" />
      <Column dataField="notionalValue" columnAutoWidth="true" dataType="number" format="###########" />
      <Column dataField="currency" columnAutoWidth="true" dataType="string" />
      <Column dataField="exchange" columnAutoWidth="true" dataType="string" />

      <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
      <Paging defaultPageSize={200} />

      <Summary calculateCustomSummary={calculateCustomSummary}>
        <GroupItem
          column="marketValue"
          name="customSummary1"
          summaryType="sum"
          showInColumn='marketValue'
          valueFormat="millions"
          showInGroupFooter={false}
          alignByColumn={true}
        />

        <GroupItem
          column="weight"
          name="customSummary1"
          summaryType="sum"
          showInColumn='weight'
          valueFormat="###.##"
          showInGroupFooter={false}
          alignByColumn={true}
        />
        <GroupItem
          column="notionalValue"
          name="customSummary1"
          summaryType="sum"
          showInColumn='notionalValue'
          valueFormat="millions"
          showInGroupFooter={false}
          alignByColumn={true}
        />
        <TotalItem
          column="marketValue"
          name="customSummary1"
          summaryType="sum"
          showInColumn='marketValue'
          valueFormat="millions"
        />

        <TotalItem
          column="weight"
          name="customSummary1"
          summaryType="sum"
          showInColumn='weight'
          valueFormat="#00.00"
        />
        <TotalItem
          column="notionalValue"
          name="customSummary1"
          summaryType="sum"
          showInColumn='notionalValue'
          valueFormat="millions"
        />

      </Summary>


    </DataGrid>
  </React.Fragment>
);


 
